import { createList } from 'shared/pages'
export default [
  {
    path: '',
    name: 'sale_list',
    component: () =>
      import('./List').then(config => createList(config.default)),
  },
]
